<template>
  <div class="trade-data">
    <van-row class="trade-data-head">
      <van-col :span="12">
        <span class="table-head">{{ $t('trade.price') }}</span>
      </van-col>
      <van-col :span="12" class="txt-right">
        <span class="table-head">{{ $t('trade.num') }}</span>
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24" v-for="item in sellindex" :key="'sell' + item">
        <div
          class="trade-date-item"
          v-if="selldata[item] && selldata[item].price && selldata[item].amount"
        >
          <div
            class="trade-date-item-bg"
            :style="
              'width:' +
              ((selldata[item].priceratio !== selldata[item].priceratio) !=
              undefined
                ? selldata[item].priceratio
                : 0) +
              '%;'
            "
          ></div>
          <div style="display: none">
            {{ selldata[item].amount }} - {{ selldata[item].lastamount }}
          </div>
          <div class="trade-date-item-price data-down">
            {{ parseFloat(selldata[item].price).toFixed(6) }}
          </div>
          <div class="trade-date-item-num">
            {{ parseFloat(selldata[item].amount).toFixed(6) }}
          </div>
        </div>
        <div v-else style="height: 37px; text-align: center">
          <van-loading />
        </div>
      </van-col>
      <van-col :span="24" style="margin: 8px 0">
        <p
          class="trade-date-price"
          :class="tradetype == 0 ? 'data-up' : 'data-down'"
        >
          {{ parseFloat(tick.close).toFixed(8) }}
        </p>
        <span class="trade-date-price-desc"
          >&#8776; {{ parseFloat(tick.close).toFixed(2) }}</span
        >
      </van-col>
      <van-col :span="24" v-for="item in buyindex" :key="'buy' + item">
        <div
          class="trade-date-item"
          v-if="buydata[item] && buydata[item].price && buydata[item].amount"
        >
          <div
            class="trade-date-item-bg1"
            :style="
              'width:' +
              ((buydata[item].priceratio !== buydata[item].priceratio) !=
              undefined
                ? buydata[item].priceratio
                : 0) +
              '%;'
            "
          />
          <div class="trade-date-item-price data-up">
            {{ parseFloat(buydata[item].price).toFixed(6) }}
          </div>
          <div class="trade-date-item-num">
            {{ parseFloat(buydata[item].amount).toFixed(6) }}
          </div>
        </div>
        <div v-else style="height: 37px; text-align: center">
          <van-loading />
        </div>
      </van-col>
    </van-row>
    <div style="position: absolute; left: 10px; bottom: 0px">
      <svg-icon
        icon-class="pan1"
        class="btn-pan border-blue"
        @click="toall()"
      />
      <svg-icon icon-class="pan2" class="btn-pan" @click="tobuy()" />
      <svg-icon icon-class="pan3" class="btn-pan" @click="tosell()" />
    </div>
  </div>
</template>

<script>
import pako from 'pako'
export default {
  name: 'TradeData',
  props: ['symbol', 'tradetype'],
  computed: {
    safeSymbol () {
      return this.symbol || ''
    },
    safeTradeType () {
      return this.tradetype || 0
    }
  },
  watch: {
    symbol (val) {
      if (val && val.length > 0) {
        this.getLstData()
      }
    },
    tradetype () {}
  },
  data () {
    return {
      socket: null,

      timer: null,
      timer1: null,
      tick: {},
      buydata: [],
      selldata: [],
      buyindex: 5,
      sellindex: 5
    }
  },
  mounted () {
    const that = this
    // this.getLstData()
    this.getDayData()
    /*
    this.$nextTick(() => {
      that.timer = setInterval(() => {
        that.getLstData();
      }, 2000);
    });
    */
    this.$nextTick(() => {
      that.timer1 = setInterval(() => {
        that.getDayData()
      }, 5000)
    })
    this.$nextTick(() => {
      // this.initWebSocket()
    })
  },
  methods: {
    toall () {
      this.buyindex = 5
      this.sellindex = 5
    },
    tobuy () {
      this.buyindex = 9
      this.sellindex = 0
    },
    tosell () {
      this.buyindex = 0
      this.sellindex = 9
    },
    getDayData () {
      if (this.safeSymbol != '') {
        fetch('/huobiapi/market/detail?symbol=' + this.safeSymbol)
          .then(res => res.json())
          .then(data => {
            if (data.status == 'ok') {
              this.tick = data.tick
              this.$emit('change-price', this.tick)
            }
          })
      }
    },
    loadData (data) {
      if (data && data.tick && data.tick.data) {
        data.tick.data.forEach(element => {
          if (element.direction == 'buy') {
            let tmp_data = this.buydata.filter(
              e =>
                e.id ==
                element.id.toLocaleString('fullwide', { useGrouping: false })
            )[0]
            if (tmp_data) {
              this.$set(tmp_data, 'lastprice', tmp_data.price)
              tmp_data.price = element.price

              this.$set(tmp_data, 'lastamount', tmp_data.amount)
              tmp_data.amount = element.amount

              this.$set(
                tmp_data,
                'priceratio',
                ((tmp_data.amount - tmp_data.lastamount) /
                  tmp_data.lastamount) *
                  100
              )
              this.buydata.filter(e => e.id == element.id)[0] = tmp_data
            } else {
              this.buydata.unshift(element)
            }
          } else if (element.direction == 'sell') {
            let tmp_data = this.selldata.filter(
              e =>
                e.id ==
                element.id.toLocaleString('fullwide', { useGrouping: false })
            )[0]
            if (tmp_data) {
              this.$set(tmp_data, 'lastprice', tmp_data.price)
              tmp_data.price = element.price

              this.$set(tmp_data, 'lastamount', tmp_data.amount)
              tmp_data.amount = element.amount

              this.$set(
                tmp_data,
                'priceratio',
                ((tmp_data.amount - tmp_data.lastamount) /
                  tmp_data.lastamount) *
                  100
              )
              this.selldata.filter(e => e.id == element.id)[0] = tmp_data
            } else {
              this.selldata.unshift(element)
            }
          }
        })

        this.buydata.sort((a, b) => b.ts - a.ts)
        this.selldata.sort((a, b) => b.ts - a.ts)
      }
    },
    async getLstData () {
      if (this.safeSymbol != '') {
        /*
        await this.$http({
          method: "post",
          url: "getHuoBiTradeFromRedis",
          data: {symbol: this.safeSymbol},
        }).then((res) => {
          // this.selldata = res.data.sell
          // this.buydata = res.data.buy
          this.loadData(res.data.sell,res.data.buy)
        });
        */
        fetch(
          '/huobiapi/market/history/trade?size=100&symbol=' + this.safeSymbol
        )
          .then(res => res.json())
          .then(data => {
            if (data.status == 'ok') {
              this.selldata = []
              this.buydata = []
              for (let i = 0; i < data.data.length; i++) {
                const tmp = data.data[i].data[0]
                if (tmp.direction == 'sell') {
                  tmp.id = tmp.id.toLocaleString('fullwide', {
                    useGrouping: false
                  })
                  this.selldata.unshift(tmp)
                }
                if (tmp.direction == 'buy') {
                  tmp.id = tmp.id.toLocaleString('fullwide', {
                    useGrouping: false
                  })
                  this.buydata.unshift(tmp)
                }
                if (i >= 100) {
                  break
                }
              }

              this.buydata.sort((a, b) => b.ts - a.ts)
              this.selldata.sort((a, b) => b.ts - a.ts)
              this.initWebSocket()
            }
          })
      }
    },

    initWebSocket () {
      this.socket = new WebSocket('wss://api-aws.huobi.pro/ws')

      this.socket.onopen = () => {
        this.sendMessage({
          sub: 'market.btcusdt.trade.detail',
          symbol: this.safeSymbol
        }) // 认证示例
      }

      this.socket.onmessage = event => {
        const data = event.data
        const that = this
        let reader = new FileReader()
        reader.onload = function (e) {
          let ploydata = new Uint8Array(e.target.result)
          let msg = pako.inflate(ploydata, { to: 'string' })
          if (msg.indexOf('ping') != -1) {
            that.sendMessage('pong')
          } else {
            that.loadData(JSON.parse(msg))
          }
        }
        reader.readAsArrayBuffer(data, 'utf-8')
      }

      this.socket.onerror = error => {
        console.error('WebSocket error:', error)
      }

      this.socket.onclose = event => {
        console.log('WebSocket closed:', event.reason)
      }
    },
    sendMessage (message) {
      if (this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(JSON.stringify(message))
      }
    }
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
    if (this.timer1) clearInterval(this.timer1)

    this.socket.close()
  }
}
</script>

<style></style>
